import { ApiServiceV1 } from '@services/api.service';

export const OperatorsApiService = {
  addMachine({ suffix, operatorId, data }) {
    return ApiServiceV1.post(`${suffix}/operator/${operatorId}/machine`, { machine: data });
  },

  removeMachine({ suffix, operatorId, data }) {
    return ApiServiceV1.delete(`${suffix}/operator/${operatorId}/machine/${data}`);
  },

  addLocation({ suffix, operatorId, data }) {
    return ApiServiceV1.post(`${suffix}/operator/${operatorId}/location`, { location: data });
  },

  removeLocation({ suffix, operatorId, data }) {
    return ApiServiceV1.delete(`${suffix}/operator/${operatorId}/location/${data}`);
  },
};
